<template>
  <div class="fx" style="flex-direction: column; width: 100%">
    <el-row class="content-head" style="width: 100%" v-if="HeadShow">
      <el-col :span="24" class="content_title">
        <el-tabs
          style="flex:1"
          v-model="editableTabsValue"
          type="card"
          closable
          @tab-remove="removeTab"
          @tab-click="clickTab"
        >
          <el-tab-pane
            v-for="item in getTabList"
            :key="item.path"
            :label="item.title"
            :name="item.path"
            class="table_tab"
          >
            <span slot="label">
              <span
                :class="['tab_item', $route.path == item.path ? 'icon' : '']"
              >
                {{ item.title }}</span
              >
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="fx head-right-icon" v-if="isHaveAdd">
          <p @click="toAdd">
            <i :class="addIcon"></i>
            &nbsp;&nbsp;{{ addText }}
          </p>
        </div>
        <slot name="headRight"></slot>
      </el-col>
    </el-row>
    <el-row
      class="fx_3"
      style="overflow-x: hidden; overflow-y: auto; width: 100%"
    >
      <div style="height: 8px; width: 100%"></div>
      <el-row class="content-search" v-if="isShow">
        <el-row>
          <slot name="search">
            <searchComponents
              :searchData="searchData"
              ref="search"
              @sendUserSearch="getUserSearch"
              v-if="isShow"
              :toUp="toUp"
              :down="down"
            >
            </searchComponents>
          </slot>
          <slot name="searchBottom"></slot>
        </el-row>
      </el-row>

      <el-row>
        <el-col :span="24" class="">
          <div class="table-content">
            <slot name="table"></slot>
            <el-row v-if="isShowBottom">
              <div :span="24" class="table_bottom" style="display: flex">
                <el-pagination
                  v-if="isHavePagination"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="pagination.currentPage"
                  :page-sizes="sizes"
                  background
                  :page-size="pagination.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pagination.total"
                ></el-pagination>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import searchComponents from "./search-components";
export default {
  components: {
    searchComponents,
  },
  props: {
    HeadShow: {
      type: Boolean,
      default: true,
    },
    exportUrl: [String],
    sizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    pagination: {
      // 分页数据
      type: Object,
      default: () => {},
    },
    toUp: [String], // 会员列表数据
    down: [String], // 会员列表数据
    isShow: {
      //是否显示搜索
      type: Boolean,
      default: true,
    },
    searchData: {
      // 搜索的数据
      type: Function,
      default: () => {},
    },
    isHavePagination: {
      //是否有分页
      type: Boolean,
      default: true,
    },
    isHaveExport: {
      //是否有导出
      type: Boolean,
      default: true,
    },
    isHaveAdd: {
      //是否有添加
      type: Boolean,
      default: true,
    },
    addText: {
      type: String,
      default: "添加",
    },
    addIcon: {
      type: String,
      default: "el-icon-plus",
    },
    isShowBottom: {
      //是否显示底部
      type: Boolean,
      default: true,
    },
    isCollection: {
      //是否显示收款码
      type: Boolean,
      default: false,
    },
    orderStatus: [String], // 订单列表数据
  },
  data() {
    return {
      dia_show: false,
      iframeurl: "",
      editableTabsValue: "/index/accessad",
    };
  },

  methods: {
    clearSearch() {
      this.$refs.search.clearSearch();
    },
    getUserSearch(val) {
      this.$emit("sendUserSearch", val);
    },
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    toAdd() {
      this.$emit("toAdd");
    },
    removeTab(name) {
      let list = [...this.navList];
      let index = list.findIndex((item) => item.path == name);
      if (list.length == 1) {
        this.$router.push(this.$store.state.menu_path);
        this.$store.commit("setNavText", "首页");
      } else {
        if (name == this.editableTabsValue) {
          if (index !== list.length - 1) {
            this.$router.push(list[index + 1].path);
          } else {
            this.$router.push(list[index - 1 || 0].path);
          }
        }
      }

      list.splice(index, 1);
      this.$store.commit("setNavList", list);
    },
    clickTab(tab) {
      if (this.$route.path == tab.name) return;
      let list = [...this.navList];
      this.$store.commit("setNavText", list[tab.index].navText);
      this.$router.push(tab.name);
    },
  },

  computed: {
    ...mapState({ navList: (state) => state.navList }),
    getTabList() {
      let navItem = this.navList.find((item) => item.path === this.$route.path);
      this.editableTabsValue = navItem ? navItem.path : this.$route.path;
      return this.navList;
    },
  },

  watch: {
    // $route(to, from) {
    //   let navItem = this.navList.find((item) => item.path === to.path);
    //   this.editableTabsValue = navItem ? navItem.name : to.path;
    // },
  },
};
</script>

<style scoped lang="less">
.recharge_sum {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  padding-left: 10px;
}

.recharge_sum p {
  font-size: 14px;
  line-height: 32px;
  padding-right: 50px;
  text-align: left;
}

.recharge_sum span {
  font-size: 14px;
  font-weight: bold;
}

.head-right-box {
  justify-content: flex-end;
}

#QRCode {
  width: 240px !important;
  height: 240px !important;
  margin: 0 auto;
}
/deep/.el-tabs__header {
  margin-bottom: 0px !important;
  border-bottom: none !important;
}
/deep/.el-tabs__nav {
  border-bottom: 1px solid #e4e7ed !important;
  border-radius: 4px !important;
}
/deep/.el-tabs__item {
  height: 30px !important;
  line-height: 30px;
}

.tab_item {
  position: relative;
  padding-left: 15px;
  &::before {
    content: "";
    position: absolute;
    width: 8px;
    height: 8px;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    background-color: #eaedf1;
    border-radius: 50%;
  }
}

.icon {
  border-radius: 50%;
  display: inline-block;
  &::before {
    background-color: #66b1ff;
  }
}
/deep/.el-tabs__item.is-active {
  background-color: #ecf5ff;
  border-bottom: none;
}
.content_title {
  display: flex;
  justify-content: space-between;
}
</style>
